export const extractMaxWidthValue = (styleText: string): number | null => {
  const regex = /max-width:\s*(\d+)px;/;

  const match = styleText.match(regex);

  //* 매치된 결과가 있다면 숫자를 반환
  if (match && match[1]) {
    return parseInt(match[1], 10);
  }

  return null;
};
